const CategoryNavigation = (($) => {

    const ELEMENT_NAME = '.nav-category .nav-item';

    $(document).ready(() => {
        $(ELEMENT_NAME).click(function(){
            $('html, body').animate({
                scrollTop: $(this.getAttribute("href") ).offset().top-40
            }, 1700);
            return false;
        });
    });

    return CategoryNavigation;


})(jQuery);

// export default CategoryNavigation
